import React from "react";
import Carousel from "react-bootstrap/Carousel";
import "./Main.css";

import background_h from "../assets/Fondos/fondo1.png";
import background_v from "../assets/Fondos/fondoV.png";
import { HEADER_HEIGHT } from "./layout.js";

import Footer from "./Footer.js";
import { pickSlides, MOBILE_MAX } from "./sliderData.js";

class SliderHome extends React.Component {
  render() {
    const isMobile = window.innerWidth <= MOBILE_MAX;
    const footerHeight = isMobile ? 150 : 130; // matches Footer.js's own footerHeight
    const sliderHeight = `calc(100dvh - ${HEADER_HEIGHT + footerHeight}px)`;

    const slides = pickSlides(window.innerWidth);
    const Back = isMobile ? background_v : background_h;
    return (
      <div
        style={{
          position: "relative",
          backgroundImage: `url(${Back})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100dvh",
          boxSizing: "border-box",
          paddingTop: `${HEADER_HEIGHT}px`,
          paddingBottom: `${footerHeight}px`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Carousel
          indicators={isMobile}
          controls={!isMobile}
          interval={4000}
          style={{ width: "100%", height: sliderHeight }}
        >
          {slides.map(({ src, href: linkHref }, i) => {
            const img = (
              <img
                src={src}
                alt={`slide-${i + 1}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  objectPosition: "center",
                  cursor: linkHref ? "pointer" : "default",
                }}
              />
            );
            return (
              <Carousel.Item key={i} style={{ height: sliderHeight }}>
                {linkHref ? (
                  <a
                    href={linkHref}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ display: "block", height: "100%" }}
                  >
                    {img}
                  </a>
                ) : (
                  img
                )}
              </Carousel.Item>
            );
          })}
        </Carousel>

        <Footer />
      </div>
    );
  }
}

export default SliderHome;
